var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToBackInStock = void 0;

function subscribeToBackInStock({
  siteId,
  email,
  variant,
  product,
  listId,
  shouldSubscribe,
  platform,
  hostname,
  abortSignal
}) {
  const data = {
    a: siteId,
    email: email,
    variant: variant,
    product: product,
    platform: platform
  };

  if (shouldSubscribe) {
    data.g = listId !== null && listId !== void 0 ? listId : "";
    data.subscribe_for_newsletter = "true";
  }

  const urlData = new URLSearchParams(data);
  const apiHostname = hostname !== null && hostname !== void 0 ? hostname : "a.klaviyo.com";
  return fetch(`//${apiHostname}/onsite/components/back-in-stock/subscribe`, {
    method: "POST",
    body: urlData,
    signal: abortSignal
  });
}

exports.subscribeToBackInStock = subscribeToBackInStock;
export default exports;